// extracted by mini-css-extract-plugin
export var colourBase = "CJiZZ4VVYcPpG_E227c5";
export var colourDisabled = "CUtbTMtlDKDogKW5evPK";
export var colourInverted = "BgGbx4LPVxClfPmIjEwp";
export var colourNegative = "z_pJl4SCyiVpjVbo_bZg";
export var colourPositive = "fQpVsA478nTIgL0ApqdX";
export var colourSubdued = "b3_MVWPcj9jvAu3OfOdQ";
export var colourSubtle = "JueXpFzsXIvfFeaSNjtX";
export var colourUrgencyHigh = "Pia57FLkaNhkeKuuXawj";
export var colourUrgencyMedium = "gnMJrd_ur1o7I7DMgtoE";
export var colourWarning = "biVpX4ps79AtZsJ9j2Gq";
export var colourWhite = "w6x5jyA6WW_NAVwx6A13";